import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";
import Form from "../Components/form";
// import Servicetemplate from "../Components/servicetemplate";
import Digiservice from "../Components/digiservice";
import Bottomfooter from "../Components/bottomfooter";

const ServiceRoute4 = () => {
  return (
    <div>
      <Header />
      <Form
        serviceName="Digital Marketing"
        apiRoute="https://business-guru-server.vercel.app/digital-marketing"
      />
      <Digiservice />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default ServiceRoute4;
